import { Button, Modal } from "components";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

export default function GdprModal() {
  const key = "cookieConsent";
  const hasCookieConsent = useMemo(() => localStorage.getItem(key), []);
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen((p) => !p);
  };
  const handleGdpr = (value: "accepted" | "rejected") => {
    return () => {
      localStorage.setItem(key, value);
      toggle();
    };
  };
  useEffect(() => {
    if (hasCookieConsent) return;
    setTimeout(() => setIsOpen(true), 1000);
  }, [hasCookieConsent]);
  if (hasCookieConsent) return null;
  return (
    <Modal
      isOpen={isOpen}
      className="gdpr pointer-events-none [&>button]:hidden"
    >
      <Modal.Dialog className="pointer-events-auto">
        <Modal.Body>
          <p className="text-sm text-[#5E6278] font-medium">
            We use cookies to improve your experience. Read our cookie{" "}
            <Link to="/privacy" className="text-primary underline font-medium">
              Privacy policy
            </Link>{" "}
            or manage cookies.
          </p>
        </Modal.Body>
        <Modal.Footer className="flex items-center justify-start gap-2 border-t-0">
          <Button
            type="button"
            variant="solid"
            color="primary"
            onClick={handleGdpr("accepted")}
          >
            Accept all
          </Button>
          <Button
            type="button"
            variant="outline"
            color="dark"
            onClick={handleGdpr("rejected")}
          >
            Reject all
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
}
